module.exports = __webpack_public_path__ + "img/sustainable-cities-and-communities.a7368a2a.png";